import { useEffect, useState } from "react";
import { _BusinessProcess, _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable"
import { DropDown } from "../../../../theme/Component/DropDown";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import { ImportarSolicitudes } from "./ImportarSolicitudes";
import usePaginator from "../../../../theme/Component/usePaginator";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { CrearComiteCredito } from "./CrearComiteCredito";
import { ESTADO_COMITE } from "../../../../../core/services/dataBean/quickDataErpCore/CreditAccount";
import AutoChart from "../../../../../core/graph/AutoChart";
import { LoanLineSelect } from "../../../../admin/CreditPotfolio/LoanLine/LoanLineSelect";
import { toast } from "react-toastify";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../contract/select/SelectMonths";

export const BandejaSolicitudCredito = () => {

    const _credit = useDataBean(_CreditAccount);
    const _bProcess = useDataBean(_BusinessProcess);
    const { bean, setBean, lista, setLista, handleChange } = _credit;
    const modalImportar = useModal("Importar Solicitudes", MODAL_LG);
    const modalPersonalData = useModal("Información Personal", MODAL_XL);
    const modalComiteCredito = useModal("Comite de Credito", MODAL_XL);
    const modalEditar = useModal("Editar", MODAL_XL);
    const modalGraph = useModal("Grafica", MODAL_LG);
    const modalRequest = useModal("Iniciar Solicitud de Credito", MODAL_md);
    const [filter, setFilter] = useState<any>({
        State: 1,
        Year:_single.getCurrenYear(),
        Month:null
    });
    const paginador = usePaginator();
    const records = 1500;
    const [request, setRequest] = useState<any>({});

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        _credit.instance.getComiteCreditoRender(paginador.page, records, _single.cleanMap(filter)).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (records));
                paginador.setRegiPerPage(records);             
                setLista(resp.List);
            }
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: filter.State === 1, icono: 'ri-file-add-line', evento: () => { initTramite() } }
    ]

    const head = [
        { title: 'ID', property: 'IDCreditCommite', visible: true, mask: MASK_NUMBER },
        { title: 'Linea Credito', property: 'LoanLineName', visible: true },
        { title: 'Caja Nominadora', property: 'NominaName', visible: true },
        { title: 'Solicitud', property: 'AlphaCode', visible: false },
        { title: 'Fecha', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Grado', property: 'IDGradoPersonaName', visible: true },
        { title: 'Identificacion', property: 'NitDeudor', visible: true, mask: MASK_NUMBER },
        { title: 'Solicitante', property: 'DeudorName', visible: true },
        { title: 'Tiempo Servicio', property: 'TimeService', visible: true },
        { title: 'Ciudad', property: 'CiudadResidencia', visible: true },
        { title: 'Valor', property: 'AmountApprove', visible: true, mask: MASK_MONEY },
        { title: 'Plazo', property: 'Cuotes', visible: true, mask: MASK_NUMBER },
        { title: 'Codeudor', property: 'CodeudorName', visible: true },
        { title: 'Novacion', property: 'NovacionList', visible: true },
        { title: 'Concepto', property: 'Observation', visible: true },
        { title: 'Token/Codigo', property: 'TokenCredit', visible: false },
        { title: 'Estado', property: 'StateName', visible: false },
    ]

    const initTramite =()=>{
        setRequest({});
        modalRequest.open()
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Información Basica Afiliado', icono: 'ri-file-add-line', visible: true, evento: () => modalPersonalData.open() },
            { titulo: 'Editar Solicitud', icono: 'ri-file-add-line', visible: true, evento: () => modalEditar.open() },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Importar Solicitudes Crédito', permiso: null, activo: filter.State === 1 },
        { id: 2, name: 'Crear Acta Comite Crédito', permiso: null, activo: filter.State === 3 },
        { id: 3, name: 'Reporte Grafico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1)
                            modalImportar.open();
                        if (e.id === 2)
                            modalComiteCredito.open();
                        if (e.id === 3)
                            modalGraph.open();
                    }}></DropDown>
                </div>
            </div>
        )
    };

    const updateBean = () => {
        _credit.instance.updateCreditCommite(bean).then(
            (resp: any) => {
                getLista();
                modalEditar.close();
            }
        )
    }

    const startProcess = () => {

        // console.log(request)

        const payload = JSON.stringify({ ...request.line, IDAccount: request.IDAccount });
        _bProcess.instance.requestBusinessProcess(
            request.IDAccount,
            request.Obs,
            "SOLCREDITO",
            "IDLoanLine",
            request.IDLoanLine,
            payload,
            ""
        ).then((resp) => {
            toast.success(`Se ha iniciado el proceso con IDProcedureImp ${resp.AlphaCode}`);
        }).catch(() => toast.error("No se ha podido iniciar el proceso"));
    };


    return (
        <BasicPage titulo="Bandeja Solicitud Credito">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={filter.Year} onChange={(e)=>{setFilter({...filter,"Year":e})}}/>
                </div>
                <div className="col-md-2">
                    <SelectMonths idSelector={filter.Month} onChange={(e)=>{setFilter({...filter,"Month":e})}}/>
                </div>
                <div className="col-md-4">
                    <label>Estado Solicitud</label>
                    <select className="form-select" value={filter.State} onChange={(e) => { setFilter({ ...filter, "State": parseInt(e.target.value) }) }}>
                        {ESTADO_COMITE.map((item) => {
                            return (
                                <option value={item.id}>{item.name}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Afiliado" idAccount={filter.IDAccount} onChange={(e) => { setFilter({ ...filter, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-12 mt-2">
                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={head} body={lista} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}
                    // next={paginador.next}
                    // pageTop={paginador.page}
                    // back={paginador.back}
                    // records={paginador}
                    ></BasicTable>

                    <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={updateBean} onSubmitLabel="Guardar">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Estado Solicitud</label>
                                <select className="form-select" value={bean.State} onChange={(e) => { setBean({ ...bean, "State": parseInt(e.target.value) }) }}>
                                    {ESTADO_COMITE.map((item) => {
                                        return (
                                            <option value={item.id}>{item.name}</option>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Codeudor" idAccount={bean.IDAccountCodoudor} onChange={(e) => { setBean({ ...bean, "IDAccountCodoudor": e.IDAccount }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Concepto</label>
                                <textarea name="Observation" className="form-control" rows={5} value={bean.Observation} onChange={handleChange}></textarea>
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalImportar.modal} updateModal={modalImportar.setModal}>
                        <ImportarSolicitudes />
                    </Modal>
                    <Modal modal={modalPersonalData.modal} updateModal={modalPersonalData.setModal} evenOnClose={getLista}>
                        <PersonalAccountData idAffiliate={bean.IDAccount} />
                    </Modal>
                    <Modal modal={modalComiteCredito.modal} updateModal={modalComiteCredito.setModal}>
                        <CrearComiteCredito stateComite={filter.State} onCreateComite={() => { modalComiteCredito.close(); getLista() }} />
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                            xOptions={['NominaName', 'LoanLineName', 'DeudorName', 'IDGradoPersonaName', 'CiudadResidencia', 'IDGeneroName']}
                            yOptions={['AmountApprove', 'Cuotes']} />
                        {/* <PrintJson json={lista}/> */}
                    </Modal>

                    <Modal modal={modalRequest.modal} updateModal={modalRequest.setModal} eventModal={() => { startProcess() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor idAccount={request.IDAccount} label="Uusario destino de solicitud" onChange={(e) => { setRequest({ ...request, IDAccount: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-12">
                                <LoanLineSelect returnType="Object" idSelector={request.IDLoanLine} onChange={(e) => { setRequest({ ...request, line: e, IDLoanLine: e.IDLoanLine }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Justificación (sera visible para el usuario)</label>
                                <textarea className="form-control" value={request.Obs} onChange={(e) => { setRequest({ ...request, Obs: e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}